import type { ReactElement } from 'react'

import Tooltip from '~/components/Tooltip'

interface Props {
  children: ReactElement
}

const UnauthorizedTooltip = ({ children }: Props): ReactElement => {
  return (
    <Tooltip overlay={<div>You are not authorized to perform this action</div>} placement="top" trigger="hover">
      {children}
    </Tooltip>
  )
}

export default UnauthorizedTooltip
